<mat-toolbar
    id="arcus-toolbar"
    color="primary"
    class="mat-whiteframe-1dp"
    [class.fraud-alert]="notificationService.fraudAlertCount()">
    <div id="nav-div" class="d-flex justify-content-between align-items-center gap-3 w-100 flex-wrap flex-md-nowrap">
        <div id="menu-loc-nav" class="d-flex align-items-center">
            <button
                id="toolbar-logo"
                aria-label="arcus logo button"
                [routerLink]="userPreferenceService.preferences()?.HomeRoute"></button>
            <button
                id="menu-toggle"
                mat-icon-button
                (click)="layoutService.toggleNavigation()"
                aria-label="menu button">
                <fa-icon icon="bars" class="white"></fa-icon>
            </button>
            <!-- <arcus-breadcrumb></arcus-breadcrumb> -->
        </div>

        <universal-search class="mobile-universal-search d-none d-md-block"></universal-search>

        <div class="d-flex justify-content-end align-items-center gap-2">
            @if (notificationService.fraudAlertCount()) {
                <button
                    id="fraud-noitifications"
                    class="arcus-nav-button d-none d-sm-block fraud-notifications"
                    mat-icon-button
                    color="warn"
                    (click)="layoutService.openFraudNotifications()"
                    aria-label="show fraud notifications"
                    matTooltip="Fraud Notifications ({{ notificationService.fraudAlertCount() }})">
                    <fa-icon icon="skull-crossbones" class="white" size="lg"></fa-icon>
                </button>
            }

            <button
                class="arcus-nav-button"
                mat-icon-button
                (click)="supportBtn()"
                matTooltip="Contact Support"
                aria-label="Contact Support">
                <fa-icon icon="headset" class="white" size="lg"></fa-icon>
            </button>
            <button
                id="notification-toggle"
                class="arcus-nav-button d-none d-sm-block"
                mat-icon-button
                (click)="layoutService.toggleNotifications()"
                aria-label="toggle notifications menu"
                matTooltip="Notifications">
                @if (notificationService.notificationCount()) {
                    <mat-icon class="white" [matBadge]="notificationService.notificationCount()">
                        notifications_active
                    </mat-icon>
                }
                @if (!notificationService.notificationCount()) {
                    <fa-icon icon="bell" class="white" size="lg"></fa-icon>
                }
            </button>

            <button
                class="arcus-nav-button"
                mat-icon-button
                aria-label="toggle user menu button"
                [matMenuTriggerFor]="usermenu">
                <fa-layers [fixedWidth]="true">
                    <fa-icon icon="user" class="white" size="lg"></fa-icon>
                    @if (isImpersonating) {
                        <fa-icon icon="fingerprint" class="text-danger" transform="shrink-1 down-7 right-8"></fa-icon>
                    }
                </fa-layers>
            </button>

            <mat-menu #usermenu="matMenu" xPosition="before">
                <div class="d-flex flex-column">
                    <div class="pa-5 profile-menu d-flex flex-row justify-content-center align-items-center">
                        <h4 class="ma-16 white">{{ user?.FullName?.trim() || user?.Email }}</h4>
                    </div>
                    <button
                        mat-menu-item
                        (click)="router.navigate(['/settings'])"
                        (mouseenter)="preloadSettingsPreferences()"
                        class="d-flex align-items-center">
                        <fa-icon icon="gear" class="text-muted" size="lg"></fa-icon>
                        &nbsp;
                        <span>Settings</span>
                    </button>
                    <button
                        id="notification-toggle"
                        mat-menu-item
                        (click)="layoutService.toggleNotifications()"
                        class="d-flex align-items-center d-block d-md-none"
                        aria-label="toggle notifications menu">
                        @if (notificationService.notificationCount()) {
                            <mat-icon [matBadge]="notificationService.notificationCount()">
                                notifications_active
                            </mat-icon>
                        }
                        @if (!notificationService.notificationCount()) {
                            <fa-icon icon="bell" class="text-muted" size="lg"></fa-icon>
                        }
                        &nbsp;
                        <span>Notifications</span>
                    </button>
                    @if (displaySizeService?.isMobile) {
                        <button
                            id="mobile-toggle"
                            mat-menu-item
                            (click)="displaySizeService?.mobileToggle()"
                            class="d-flex align-items-center"
                            matToolTip="Toggle between Desktop Site"
                            aria-label="toggle desktop site">
                            {{ displaySizeService?.usingMobile ? "Use Desktop Site" : "Use Mobile Site" }}
                        </button>
                    }
                    @if (isImpersonating) {
                        <button
                            id="stop-impersonation"
                            mat-menu-item
                            (click)="stopImpersonating()"
                            class="d-flex align-items-center"
                            matTooltip="Stop Impersonating User"
                            aria-label="Stop Impersonation">
                            <fa-icon icon="fingerprint" class="text-muted" size="lg"></fa-icon>
                            &nbsp;
                            <span>Stop Impersonating</span>
                        </button>
                    }
                    <button mat-menu-item (click)="logout.emit()" class="d-flex align-items-center">
                        <fa-icon icon="arrow-right-from-bracket" class="text-muted" size="lg"></fa-icon>
                        &nbsp;
                        <span>Logout</span>
                    </button>
                </div>
            </mat-menu>
        </div>
    </div>
</mat-toolbar>
